import { createAsyncThunk } from '@reduxjs/toolkit';
import BrandAPI from './services';

export const fetch = createAsyncThunk('brand/fetchAll', async (params, { rejectWithValue }) => {
  try {
    const response = await BrandAPI.fetchAll(params);

    return response.data;
  } catch (err) {
    return rejectWithValue(err.response?.data);
  }
});
